var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9998 16.1998C12.9763 16.1998 16.1998 12.9763 16.1998 8.9998C16.1998 5.02335 12.9763 1.7998 8.9998 1.7998C5.02335 1.7998 1.7998 5.02335 1.7998 8.9998C1.7998 12.9763 5.02335 16.1998 8.9998 16.1998ZM7.1998 6.2998C6.70275 6.2998 6.2998 6.70275 6.2998 7.1998V10.7998C6.2998 11.2969 6.70275 11.6998 7.1998 11.6998H10.7998C11.2969 11.6998 11.6998 11.2969 11.6998 10.7998V7.1998C11.6998 6.70275 11.2969 6.2998 10.7998 6.2998H7.1998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.8c7787c6e8251baf540ed79e370707bc.svg";
export { ForwardRef as ReactComponent };